var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00039 16.784C13.2992 16.784 16.784 13.2992 16.784 9.00039C16.784 4.70163 13.2992 1.2168 9.00039 1.2168C4.70163 1.2168 1.2168 4.70163 1.2168 9.00039C1.2168 13.2992 4.70163 16.784 9.00039 16.784Z",
    fill: "#E53935"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21049 11.546L8.00309 4.2276C7.99659 3.99906 8.19167 3.8125 8.41819 3.8125H9.58205C9.80857 3.8125 10.0036 4.00114 9.99716 4.2276L9.78976 11.546C9.78332 11.7727 9.60326 11.9611 9.37466 11.9611H8.62559C8.39699 11.9611 8.21698 11.7746 8.21049 11.546Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99418 14.127C9.42406 14.127 9.77254 13.7785 9.77254 13.3487C9.77254 12.9188 9.42406 12.5703 8.99418 12.5703C8.5643 12.5703 8.21582 12.9188 8.21582 13.3487C8.21582 13.7785 8.5643 14.127 8.99418 14.127Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.193be3f144b0af615013c9456e868b3b.svg";
export { ForwardRef as ReactComponent };